export const welcome = [
  {
    English: "Welcome to the Quiz! Select a theme to begin.",
    Ukrainian: "Ласкаво просимо до тесту! Щоб почати, виберіть тему.",
    Polish: "Witamy w teście! Aby rozpocząć, wybierz motyw.",
    German: "Willkommen zum Test! Wählen Sie zunächst ein Thema aus.",
  },
];
